import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ContentfulImage from '../ContentfulImage';
import Placeholder from '../Placeholder';
import Markdown from '../Markdown';

import {
  Wrapper,
  Title,
  ProductsWrapper,
  Product,
  ProductInfo,
  ProductTitle,
  ProductDescription,
  ImageWrapper,
  TreatmentType,
  InfoWrapper,
  // ProductConditions,
  SalonSolutionsWrapper,
  PlaceholderWrapper,
} from './TreatmentRecommendations.style';

const getRangeSlug = rangeType => {
  switch (rangeType) {
    case 'productRangeSkinBodyCare':
      return 'skin-body-care';
    case 'productRangeHairCare':
      return 'hair-care';
    case 'productRangeHairColor':
      return 'hair-color';
    case 'productRangeMakeUp':
      return 'make-up';
    case 'productRangeMens':
      return 'mens';
    case 'productRangePerm':
      return 'perm';
    case 'productRangeStyling':
      return 'styling';
    default:
      return null;
  }
};

const TreatmentRecommendations = ({ locale, ranges, copy, salonImage, salonText }) => (
  <Wrapper>
    <Title>{copy.home_treatment_recommendations || <Placeholder w="200px" h="20px" />}</Title>
    <ProductsWrapper>
      {ranges.map((range, i) => {
        if (!range) {
          return (
            <div style={{ marginBottom: '30px' }} key={`range-${Math.floor(Math.random() * 1000)}`}>
              <Placeholder w="100%" h="200px" />
            </div>
          );
        }
        /* let rangeImage = null;
        if (range.productLists && range.productLists.length > 0) {
          const productListWithProducts = range.productLists.find(
            productList => productList.products && productList.products.length > 0
          );
          if (productListWithProducts) {
            const productWithVariants = productListWithProducts.products.find(
              product => product.variants && product.variants.length > 0
            );
            if (productWithVariants) {
              const variantWithImage = productWithVariants.variants.find(variant => variant.image);
              if (variantWithImage) {
                rangeImage = variantWithImage.image;
              }
            }
          }
        } */
        return (
          <Product key={`${range.name}${range.contentType}`}>
            {range.productImage && (
              <ImageWrapper>
                <ContentfulImage
                  src={range.productImage}
                  options={{
                    size: range.productImage.file.details.image.width,
                    objectFit: 'contain',
                    w: '100%',
                    h: '100%',
                  }}
                />
              </ImageWrapper>
            )}

            <ProductInfo>
              <InfoWrapper>
                <TreatmentType>{i === 0 ? copy.treatment_for_hair : copy.treatment_for_scalp}</TreatmentType>
                <ProductTitle>{range.name}</ProductTitle>
                <Markdown Component={ProductDescription} src={range.description} />
                {/* {range.targetConditions && (
                  <ProductConditions>
                    {range.targetConditions.map(condition => <li key={condition}>{condition}</li>)}
                  </ProductConditions>
                )} */}

                <Link
                  to={`/${locale}/range/${getRangeSlug(range.contentType)}/${range.slug}`}
                  href={`/${locale}/range/${getRangeSlug(range.contentType)}/${range.slug}`}
                >
                  {copy.view_product}
                </Link>
              </InfoWrapper>
            </ProductInfo>
          </Product>
        );
      })}

      <SalonSolutionsWrapper>
        <Title>{copy.salon_treatments_recommendation || <Placeholder w="200px" h="20px" />}</Title>
        <Product key="salon-solutions">
          <ImageWrapper>
            {salonImage ? (
              <ContentfulImage
                src={salonImage}
                options={{
                  size: salonImage.file.details.image.width,
                  objectFit: 'contain',
                  w: '100%',
                  h: '100%',
                }}
              />
            ) : (
              <PlaceholderWrapper>
                <Placeholder w="100%" h="100%" />
              </PlaceholderWrapper>
            )}
          </ImageWrapper>

          <ProductInfo>
            <InfoWrapper>
              <TreatmentType>{copy.salon_solutions}</TreatmentType>
              {salonText ? (
                <Markdown Component={ProductDescription} src={salonText} />
              ) : (
                <Placeholder w="100%" h="200px" />
              )}

              <Link
                to={`/${locale}/range/hair-care/salon-solutions`}
                href={`/${locale}/range/hair-care/salon-solutions`}
              >
                {copy.view_product}
              </Link>
            </InfoWrapper>
          </ProductInfo>
        </Product>
      </SalonSolutionsWrapper>
    </ProductsWrapper>
  </Wrapper>
);

TreatmentRecommendations.defaultProps = {
  ranges: [],
  copy: {
    home_treatment_recommendations: 'Recommended treatments',
    treatment_for_hair: 'Treatment for your hair',
    treatment_for_scalp: 'Treatment for your scalp',
    view_product: 'View Product',
    salon_solutions: 'Salon Solutions',
  },
  salonImage: null,
  salonText: '',
};

TreatmentRecommendations.propTypes = {
  ranges: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape(),
      name: PropTypes.string,
      slug: PropTypes.string,
    })
  ),
  copy: PropTypes.shape({
    home_treatment_recommendations: PropTypes.string,
    treatment_for_hair: PropTypes.string,
    treatment_for_scalp: PropTypes.string,
    salon_solutions: PropTypes.string,
  }),
  locale: PropTypes.string.isRequired,
  salonImage: PropTypes.shape({}),
  salonText: PropTypes.string,
};

export default TreatmentRecommendations;



// WEBPACK FOOTER //
// ./src/components/TreatmentRecommendations/TreatmentRecommendations.js